module.exports = __webpack_public_path__ + "static/media/icon_ticket_checked.f11fad06.png";